module.exports = {
	formsPage: "/forms/",
	demoformsPage: "/demo_forms"
};
